/**
 * @generated SignedSource<<521c6dec97130ce00a43c939cbff5002>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_sku$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_sku" | "PdpSharedBlurbLeadTime_sku">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_sku";
};
export type PdpRespSidebarBlurbs_sku$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_sku",
  "selections": [
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarBlurbShipping_sku"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbLeadTime_sku"
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "aeda1ba65f61ba908259f90b4984ebe3";

export default node;
